module.exports = __webpack_public_path__ + "static/img/undraw_podcast_q6p7.4bb5b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_podcast_q6p7.png
// module id = zvpS
// module chunks = 3